import { QueryClient } from '@tanstack/react-query';

/**
 * Default TanStack Query client configuration.
 * Matches Trinity AI patterns: retry once, no refetch on window focus,
 * 30-second stale time for background refetch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

/**
 * Creates a new QueryClient instance for testing or isolated use.
 * @param overrides - Optional partial default options to override defaults
 */
export function createQueryClient(
  overrides?: Partial<ConstructorParameters<typeof QueryClient>[0]>,
): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
        ...overrides?.defaultOptions?.queries,
      },
      mutations: {
        ...overrides?.defaultOptions?.mutations,
      },
    },
  });
}
